export default "__VITE_ASSET__bfe28177__"